function AdminFooter() {
  return (
    <div className="app-wrapper-footer" style={{backgroundColor:"transparent"}}>
      <div className="app-footer" style={{backgroundColor:"transparent"}}>
        <div className="app-footer__inner" style={{backgroundColor:"transparent"}}>
          <div className="app-footer-right">
            <ul className="nav">
              <li className="nav-item">
                <a
                  href="https://www.triosoft.ai/"
                  className="nav-link"
                  target="_blank"
                >
                  Triosoft Technologies Pvt. Ltd. 2024
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminFooter;
